import { AvailableLanguage } from "@/types/Language";

export const availableLanguages = new Set<AvailableLanguage>([
  "en",
  "es",
  "it",
  "de",
  "fr",
  "nl",
  "pl",
  "pt",
  "dk",
  "no",
  "fi",
  "se",
  "cs",
]);

export const automaticTranslationLanguages = new Set<AvailableLanguage>([
  "en",
  "es",
  "it",
  "de",
  "fr",
  "nl",
  "pl",
  "pt",
  "no",
  "fi",
]);
